module.exports = __webpack_public_path__ + "img/trash-01.54fa01a2.svg";